export default "__VITE_ASSET__hN3OEe2W__"